import {getAuth} from "firebase/auth";
import {initializeApp} from 'firebase/app';
import 'firebase/auth';

const firebase = {
    apiKey: "AIzaSyB5OTlOpzZUX_LpPmEaz1Hxv2QYmgRes7Q",
    authDomain: "cmrna-design-nocturna.firebaseapp.com",
    projectId: "cmrna-design-nocturna",
    storageBucket: "cmrna-design-nocturna.appspot.com",
    messagingSenderId: "755268329915",
    appId: "1:755268329915:web:8c6e8da70412f244dbe49e"
}

export const app = initializeApp(firebase);
export const auth = getAuth(app);






